var _TextComponent_instances, _TextComponent_ps, _TextComponent_compRef, _TextComponent_state, _TextComponent_init;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { replaceAndPreserveInnermostParentHtmlElement } from './utils';
import { BaseComponent } from '../BaseComponent';
import { ComponentsNamespaceErrorCode, createComponentsNamespaceError, } from '../../errors';
export class TextComponent extends BaseComponent {
    constructor(compRef, ps) {
        super();
        _TextComponent_instances.add(this);
        this.compRef = compRef;
        _TextComponent_ps.set(this, void 0);
        _TextComponent_compRef.set(this, void 0);
        _TextComponent_state.set(this, {
            text: '',
        });
        this.type = 'text';
        // TODO: try to get rid of storing compref and ps
        __classPrivateFieldSet(this, _TextComponent_compRef, compRef, "f");
        __classPrivateFieldSet(this, _TextComponent_ps, ps, "f");
        __classPrivateFieldGet(this, _TextComponent_instances, "m", _TextComponent_init).call(this);
    }
    getProp(prop) {
        switch (prop) {
            case 'text': {
                return __classPrivateFieldGet(this, _TextComponent_state, "f").text;
            }
            default: {
                return null;
            }
        }
    }
    setProp(prop, value) {
        switch (prop) {
            case 'text': {
                const dsItem = __classPrivateFieldGet(this, _TextComponent_ps, "f").ds.components.data.get(__classPrivateFieldGet(this, _TextComponent_compRef, "f"));
                const maybeHtmlContent = dsItem.text || '';
                const newText = replaceAndPreserveInnermostParentHtmlElement(value ?? '', maybeHtmlContent);
                __classPrivateFieldGet(this, _TextComponent_state, "f").text = newText;
                __classPrivateFieldGet(this, _TextComponent_ps, "f").ds.components.data.update(__classPrivateFieldGet(this, _TextComponent_compRef, "f"), {
                    ...__classPrivateFieldGet(this, _TextComponent_ps, "f").ds.components.data.get(__classPrivateFieldGet(this, _TextComponent_compRef, "f")),
                    text: newText,
                });
                return;
            }
            default: {
                throw createComponentsNamespaceError(ComponentsNamespaceErrorCode.UnknownSetProp, 'text components supports only "text" property');
            }
        }
    }
}
_TextComponent_ps = new WeakMap(), _TextComponent_compRef = new WeakMap(), _TextComponent_state = new WeakMap(), _TextComponent_instances = new WeakSet(), _TextComponent_init = function _TextComponent_init() {
    const data = __classPrivateFieldGet(this, _TextComponent_ps, "f").ds.components.data.get(__classPrivateFieldGet(this, _TextComponent_compRef, "f"));
    __classPrivateFieldGet(this, _TextComponent_state, "f").text = data.text;
};
//# sourceMappingURL=TextComponent.js.map